import { AssortmentPricesComparisonDTO } from '../dto';
import { AssortmentPrices } from './AssortmentPrices';
import { PriceRoundingBrand } from '@retail/rounding/types';

export interface AssortmentPricesComparisonProps {
  base: AssortmentPrices;
  draft: AssortmentPrices;
}

export class AssortmentPricesComparison {
  base: AssortmentPrices;
  draft: AssortmentPrices;

  constructor({ base, draft }: AssortmentPricesComparisonProps) {
    this.base = base;
    this.draft = draft;
  }

  static fromDTO = (
    dto: AssortmentPricesComparisonDTO,
    selectedBrand: PriceRoundingBrand
  ): AssortmentPricesComparison =>
    new AssortmentPricesComparison({
      base: AssortmentPrices.fromDTO(dto.base, selectedBrand),
      draft: AssortmentPrices.fromDTO(dto.draft, selectedBrand),
    });
}
